
import { store , defineIdsNeeds } from '../state/redux';



 function filtreformules(ficheclient){
        let listIds =[] ;
        const {need_hospi,need_orthodontie,need_protheses,need_lentilles,need_lunettes,need_prevention,need_implant,need_specialiste}=ficheclient ;

        const cond_all1 = [need_hospi,need_orthodontie,need_protheses,need_lentilles,need_lunettes,need_prevention,need_implant,need_specialiste].every(b=>b===0||b===undefined) ;

        if(cond_all1){store.dispatch(defineIdsNeeds([])) ;  return}
   
        const monfiltre = (formule) =>{
                const critere_hospi = need_hospi ===2 ?(formule.hospi>=2 ): need_hospi ===1 ?(formule.hospi>=1 ): (formule.hospi>=0 );
                const critere_orthodontie = need_orthodontie ===2 ?(formule.dentaire_orthodontie_nb>=2 ): need_orthodontie ===1 ?(formule.dentaire_orthodontie_nb>=1 ): (formule.dentaire_orthodontie_nb>=0 );
                const critere_protheses = need_protheses ===2 ?(formule.dentaire_prothese_nb>=2 ): need_protheses ===1 ?(formule.dentaire_prothese_nb>=1 ): (formule.dentaire_prothese_nb>=0 );
                const critere_lentilles = need_lentilles ===2 ?(formule.optique_lentilles_nb>=2 ): need_lentilles ===1 ?(formule.optique_lentilles_nb>=1 ): (formule.optique_lentilles_nb>=0 );
                const critere_lunettes = need_lunettes ===2 ?(formule.optique_lunettes_nb>=2 ): need_lunettes ===1 ?(formule.optique_lunettes_nb>=1 ): (formule.optique_lunettes_nb>=0 );
                const critere_prevention = need_prevention ===2 ?(formule.prevention>=2 ): need_prevention  ===1 ?(formule.prevention>=1 ): (formule.prevention>=0 );
                const critere_implant = need_implant ===2 ?(formule.dentaire_implant_nb>=2 ):need_implant ===1 ?(formule.dentaire_implant_nb>=1 ): (formule.dentaire_implant_nb>=0 );
                const critere_specialistes= need_specialiste ===2 ?(formule.consults_specialistes_nb>=2 ): need_specialiste ===1 ?(formule.consults_specialistes_nb>=1 ): (formule.consults_specialistes_nb>=0 );
              
                (critere_hospi && critere_orthodontie && critere_protheses && critere_lentilles && critere_lunettes && critere_prevention && critere_implant && critere_specialistes) && listIds.push(formule.id) ;
        }

        store.getState().formules.datas?.forEach(formule=>monfiltre(formule))  ;

        store.dispatch(defineIdsNeeds(listIds)) ;
}




export default filtreformules

